import React, { useState, useEffect } from "react";
import BaseFooter from "../Ui/Footer/BaseFooter";

const Footer = () => {

    return (
        <BaseFooter
            links={[
                { name: "Главная", url: "/" },
                { name: "Имущество", url: "/Boutique/Details" },
                { name: "Тарифы", url: "/articles/tariffs" },
                { name: "Контакты", url: "/Contacts/Index" },
                { name: "FAQ", url: "/faq" }
            ]}
        />
    )
}

export default Footer;